import React, { Component } from "react";
import {
  Row,
  Col,
  Card,
  CardBody,
  TabContent,
  TabPane,
  NavItem,
  NavLink,
  Label,
  Input,
  Form,
  FormGroup,
  Progress,
  Container,
  Button,
} from "reactstrap";

import classnames from "classnames";
import { Link } from "react-router-dom";
import { api_route } from "../../Api-config/config";
import { message, notification } from "antd";
//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb";

class CreateUser extends Component {
  constructor(props) {
    super(props);
    this.state = {
      breadcrumbItems: [
        { title: "Delisted Stocks", link: "#" },
        { title: "Add Customer", link: "#" },
      ],
      activeTab: 1,
      activeTabProgress: 1,
      progressValue: 25,
      buyerName: "",
      panNo: "",
      email: "",
      contactNo: "",
      bankName: "",
      bankAc: "",
      acType: "",
      category: "Retailer",
      ifscCode: "",
      branch: "",
      dpName: "",
      dpid: "",
      address: "",
      city: "",
      state: "",
      pincode: "",
      cmnt1: "",
    };
    this.toggleTab.bind(this);
    this.toggleTabProgress.bind(this);
  }

  handleOnChange = (e) => {
    this.setState({
      [e.target.id]: e.target.value,
    });
  };

  resetValue = () => {
    document.getElementById("buyerName").value = "";
    document.getElementById("panNo").value = "";
    document.getElementById("email").value = "";
    document.getElementById("contactNo").value = "";
    document.getElementById("bankName").value = "";
    document.getElementById("bankAc").value = "";
    document.getElementById("acType").value = "";
    document.getElementById("category").value = "";
    document.getElementById("ifscCode").value = "";
    document.getElementById("dpName").value = "";
    document.getElementById("dpid").value = "";
    document.getElementById("address").value = "";
    document.getElementById("city").value = "";
    document.getElementById("state").value = "";
    document.getElementById("pincode").value = "";
    document.getElementById("cmnt1").value = "";
  };

  handleSubmit = () => {
    const requestOptions = {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        buyerName: this.state.buyerName,
        panNo: this.state.panNo,
        address: this.state.address,
        city: this.state.city,
        pincode: this.state.pincode,
        bankName: this.state.bankName,
        contactNo: this.state.contactNo,
        email: this.state.email,
        cmnt1: this.state.cmnt1,
        bankAc: this.state.bankAc,
        acType: this.state.acType,
        category: this.state.category,
        ifscCode: this.state.ifscCode,
        branch: this.state.branch,
        dpName: this.state.dpName,
        dpid: this.state.dpId,
        state: this.state.state,
        dealerId: sessionStorage.getItem("dealerId"),
      }),
    };
    fetch(api_route + "/customer/addCustomerforBilling", requestOptions)
      .then((response) => response.json())
      .then((data) => {
        if (data.success) {
          message.success("Customer Added successfully !");
          this.resetValue();
          this.toggleTab(1);
        } else {
          notification.error({ message: data.msg });
        }
      });
  };

  toggleTab(tab) {
    if (this.state.activeTab !== tab) {
      if (tab >= 1 && tab <= 4) {
        this.setState({
          activeTab: tab,
        });
      }
    }
  }

  toggleTabProgress(tab) {
    if (this.state.activeTabProgress !== tab) {
      if (tab >= 1 && tab <= 4) {
        this.setState({
          activeTabProgress: tab,
        });

        if (tab === 1) {
          this.setState({ progressValue: 25 });
        }
        if (tab === 2) {
          this.setState({ progressValue: 50 });
        }
        if (tab === 3) {
          this.setState({ progressValue: 75 });
        }
        if (tab === 4) {
          this.setState({ progressValue: 100 });
        }
      }
    }
  }

  render() {
    return (
      <React.Fragment>
        <div className="page-content">
          <Container fluid={true}>
            <Breadcrumbs
              title="Add Customer"
              breadcrumbItems={this.state.breadcrumbItems}
            />

            <Row>
              <Col lg="12">
                <Card>
                  <CardBody>
                    <div id="basic-pills-wizard" className="twitter-bs-wizard">
                      <ul className="twitter-bs-wizard-nav nav nav-pills nav-justified">
                        <NavItem>
                          <NavLink
                            className={classnames({
                              active: this.state.activeTab === 1,
                            })}
                            onClick={() => {
                              this.toggleTab(1);
                            }}
                          >
                            <span className="step-number">01</span>
                            <span className="step-title">User Details</span>
                          </NavLink>
                        </NavItem>
                        <NavItem>
                          <NavLink
                            className={classnames({
                              active: this.state.activeTab === 2,
                            })}
                            onClick={() => {
                              this.toggleTab(2);
                            }}
                          >
                            <span className="step-number">02</span>
                            <span className="step-title">Bank Details</span>
                          </NavLink>
                        </NavItem>
                        {/* <NavItem>
                                                                    <NavLink className={classnames({ active: this.state.activeTab === 3 })} onClick={() => { this.toggleTab(3); }} >
                                                                        <span className="step-number">03</span>
                                                                        <span className="step-title">Bank Details</span>
                                                                    </NavLink>
                                                                </NavItem>
                                                                <NavItem>
                                                                    <NavLink className={classnames({ active: this.state.activeTab === 4 })} onClick={() => { this.toggleTab(4); }} >
                                                                    <span className="step-number">04</span>
                                                                    <span className="step-title">Confirm Detail</span>
                                                                    </NavLink>
                                                                </NavItem> */}
                      </ul>
                      <TabContent
                        activeTab={this.state.activeTab}
                        className="twitter-bs-wizard-tab-content"
                      >
                        <TabPane tabId={1}>
                          <Form>
                            <Row>
                              <Col lg="6">
                                <FormGroup>
                                  <Label for="fullName">Full name</Label>
                                  <Input
                                    onChange={this.handleOnChange}
                                    type="text"
                                    className="form-control"
                                    id="buyerName"
                                  />
                                </FormGroup>
                              </Col>

                              <Col lg="6">
                                <FormGroup>
                                  <Label for="basicpill-email-input4">
                                    Email
                                  </Label>
                                  <Input
                                    onChange={this.handleOnChange}
                                    type="email"
                                    className="form-control"
                                    id="email"
                                  />
                                </FormGroup>
                              </Col>
                              {/* <Col lg="6">
                                <FormGroup>
                                  <Label>Category</Label>
                                  <select
                                    id="category"
                                    className="custom-select"
                                    onChange={this.handleOnChange}
                                  >
                                    <option defaultValue>
                                      Select Category
                                    </option>
                                    <option value="Retailer">Retailer</option>
                                    <option value="Consumer">Consumer</option>
                                  </select>
                                </FormGroup>
                              </Col> */}
                            </Row>

                            <Row>
                              <Col lg="6">
                                <FormGroup>
                                  <Label for="basicpill-phoneno-input3">
                                    Phone
                                  </Label>
                                  <Input
                                    onChange={this.handleOnChange}
                                    type="text"
                                    className="form-control"
                                    id="contactNo"
                                  />
                                </FormGroup>
                              </Col>
                              <Col lg="6">
                                <FormGroup>
                                  <Label for="basicpill-address-input1">
                                    PAN Number
                                  </Label>
                                  <Input
                                    onChange={this.handleOnChange}
                                    type="text"
                                    className="form-control"
                                    id="panNo"
                                  />
                                </FormGroup>
                              </Col>
                            </Row>

                            <Row>
                              <Col lg="6">
                                <FormGroup>
                                  <Label for="basicpill-address-input1">
                                    DP Name
                                  </Label>
                                  <Input
                                    onChange={this.handleOnChange}
                                    type="text"
                                    className="form-control"
                                    id="dpName"
                                  />
                                </FormGroup>
                              </Col>
                              <Col lg="6">
                                <FormGroup>
                                  <Label for="basicpill-address-input1">
                                    DP Id
                                  </Label>
                                  <Input
                                    onChange={this.handleOnChange}
                                    type="text"
                                    className="form-control"
                                    id="dpid"
                                  />
                                </FormGroup>
                              </Col>
                            </Row>
                            <Row>
                              <Col lg="6">
                                <FormGroup>
                                  <Label for="basicpill-address-input1">
                                    Address
                                  </Label>
                                  <textarea
                                    onChange={this.handleOnChange}
                                    id="address"
                                    className="form-control"
                                    rows="2"
                                  ></textarea>
                                </FormGroup>
                              </Col>
                              <Col lg="6">
                                <FormGroup>
                                  <Label for="basicpill-address-input1">
                                    City
                                  </Label>
                                  <Input
                                    onChange={this.handleOnChange}
                                    type="text"
                                    className="form-control"
                                    id="city"
                                  />
                                </FormGroup>
                              </Col>
                            </Row>
                            <Row>
                              <Col lg="6">
                                <FormGroup>
                                  <Label for="basicpill-address-input1">
                                    State
                                  </Label>
                                  <Input
                                    onChange={this.handleOnChange}
                                    type="text"
                                    className="form-control"
                                    id="state"
                                  />
                                </FormGroup>
                              </Col>
                              <Col lg="6">
                                <FormGroup>
                                  <Label for="basicpill-address-input1">
                                    Pin code
                                  </Label>
                                  <Input
                                    onChange={this.handleOnChange}
                                    type="text"
                                    className="form-control"
                                    id="pincode"
                                  />
                                </FormGroup>
                              </Col>
                            </Row>
                            <Row>
                              <Col>
                                <FormGroup>
                                  <Label for="basicpill-address-input1">
                                    Comment
                                  </Label>
                                  <Input
                                    onChange={this.handleOnChange}
                                    type="text"
                                    className="form-control"
                                    id="cmnt1"
                                  />
                                </FormGroup>
                              </Col>
                            </Row>
                          </Form>
                        </TabPane>
                        <TabPane tabId={2}>
                          <div>
                            <Form>
                              <Row>
                                <Col lg="6">
                                  <FormGroup>
                                    <Label for="basicpill-pancard-input5">
                                      Bank Name
                                    </Label>
                                    <Input
                                      onChange={this.handleOnChange}
                                      type="text"
                                      className="form-control"
                                      id="bankName"
                                    />
                                  </FormGroup>
                                </Col>

                                <Col lg="6">
                                  <FormGroup>
                                    <Label for="basicpill-vatno-input6">
                                      Bank Account No.
                                    </Label>
                                    <Input
                                      onChange={this.handleOnChange}
                                      type="number"
                                      className="form-control"
                                      id="bankAc"
                                    />
                                  </FormGroup>
                                </Col>
                              </Row>
                              <Row>
                                <Col lg="6">
                                  <FormGroup>
                                    <Label for="basicpill-cstno-input7">
                                      Account Type
                                    </Label>
                                    <select
                                      onChange={this.handleOnChange}
                                      className="custom-select"
                                      id="acType"
                                    >
                                      <option defaultValue>
                                        Select Account Type
                                      </option>
                                      <option value="AE">Savings</option>
                                      <option value="VI">Current</option>
                                    </select>
                                  </FormGroup>
                                </Col>

                                <Col lg="6">
                                  <FormGroup>
                                    <Label for="basicpill-servicetax-input8">
                                      IFSC Code
                                    </Label>
                                    <Input
                                      onChange={this.handleOnChange}
                                      type="text"
                                      className="form-control"
                                      id="ifscCode"
                                    />
                                  </FormGroup>
                                </Col>
                              </Row>
                              <Row>
                                <Col lg="6">
                                  <FormGroup>
                                    <Label for="basicpill-companyuin-input9">
                                      Branch
                                    </Label>
                                    <Input
                                      onChange={this.handleOnChange}
                                      type="text"
                                      className="form-control"
                                      id="branch"
                                    />
                                  </FormGroup>
                                </Col>
                              </Row>
                            </Form>

                            <Button color="success" onClick={this.handleSubmit}>
                              Submit
                            </Button>
                          </div>
                        </TabPane>
                      </TabContent>
                      <ul className="pager wizard twitter-bs-wizard-pager-link">
                        <li
                          className={
                            this.state.activeTab === 1
                              ? "previous disabled"
                              : "previous"
                          }
                        >
                          <Link
                            to="#"
                            onClick={() => {
                              this.toggleTab(this.state.activeTab - 1);
                            }}
                          >
                            Previous
                          </Link>
                        </li>
                        <li
                          className={
                            this.state.activeTab === 2
                              ? "next disabled"
                              : "next"
                          }
                        >
                          <Link
                            to="#"
                            onClick={() => {
                              this.toggleTab(this.state.activeTab + 1);
                            }}
                          >
                            Next
                          </Link>
                        </li>
                      </ul>
                    </div>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </Container>
        </div>
      </React.Fragment>
    );
  }
}

export default CreateUser;
